import { faTrophy } from "@fortawesome/free-solid-svg-icons/faTrophy"
import { faPersonRifle } from "@fortawesome/free-solid-svg-icons/faPersonRifle"
import { faUtensils } from "@fortawesome/free-solid-svg-icons/faUtensils"
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus"

import {
    AddOnCategory,
    BookingInternalSource,
    FeatureKey,
    ListingType,
} from "~graphql/generated/types"

import COPY from "./copy-constants"

/** Rows per page in contact searchable checklist (selection picker, manual list add). */
export const CONTACT_LIST_SEARCH_CHECKLIST_PAGE_SIZE = 15

export const DEFAULT_QUERY_LIMITS = {
    ONBOARDINGS: 10,
    CONTACTS: 50,
    CONTACT_LISTS: 100,
    DEFAULT_AVAILABILITY_RULES: 50,
    LEADS: 50,
    LEADS_BOARD: 10,
    SYNCED_CALENDARS: 10,
    QUOTE_REQUEST_BOOKING_INVITES: 3,
    BOOKING_INVITES: 10,
    FORMS: 10,
    FORM_SUBMISSIONS: 10,
    PAID_ADS_REPORTING: 100,
    PAID_FACEBOOK_ADS: 100,
    MESSAGE_TEMPLATES: 10,
    NOTIFICATION_SEND_LOGS: 10,
    OUTFITTER_CUSTOM_PROPERTIES: 100,
    AUTOMATION_RUNS: 10,
}

export const RTE_OPTIONS = {
    toolbar: [
        ["bold", "italic", "underline", "link"],
        [{ list: "ordered" }, { list: "bullet" }],
    ],
}

export const SCROLLABLE_CONTAINER = "SCROLLABLE_CONTAINER"

export const SUPPORT_CONTACTS = {
    PHONE: "+15129709123",
    EMAIL: "support@mallardbay.com",
}

export const LOCAL_STORAGE_KEYS = {
    MB_GLOBAL_OUTFITTER: "MB_GLOBAL_OUTFITTER",
    MB_GLOBAL_EVENT_ORGANIZER: "MB_GLOBAL_EVENT_ORGANIZER",
    MB_GLOBAL_PORTAL_TYPE: "MB_GLOBAL_PORTAL_TYPE",
    MB_IS_SIDEBAR_OPEN: "MB_IS_SIDEBAR_OPEN",
    USER_PREFERENCES: "USER_PREFERENCES",
    APP_PROMPT_DISMISSED: "MB_APP_PROMPT_DISMISSED",
}

export const TEST_IDS = {
    TAX_DEFINITION_ITEM: "TAX_DEFINITION_ITEM",
    TAX_DEFINITION_NAME_INPUT: "TAX_DEFINITION_NAME_INPUT",
    TAX_DEFINITION_RATE_INPUT: "TAX_DEFINITION_RATE_INPUT",
    TAX_DEFINITION_CODE_INPUT: "TAX_DEFINITION_CODE_INPUT",
    PRICING_PACKAGE_APPLIED_TAXES: "PRICING_PACKAGE_APPLIED_TAXES",
    ADD_ON_APPLIED_TAXES: "ADD_ON_APPLIED_TAXES",
    CREATE_EVENT_GROUP_BUTTON: "CREATE_EVENT_GROUP_BUTTON",
    CUSTOM_EMAIL_DOMAIN_FROM_EMAIL_INPUT:
        "CUSTOM_EMAIL_DOMAIN_FROM_EMAIL_INPUT",
    CUSTOM_EMAIL_DOMAIN_REPLY_TO_EMAIL_INPUT:
        "CUSTOM_EMAIL_DOMAIN_REPLY_TO_EMAIL_INPUT",
    TOGGLE_SWITCH_NO: "TOGGLE_SWITCH_NO",
    CHECK_NUMBER_INPUT: "CHECK_NUMBER_INPUT",
    CONTACT_LISTS_CREATE_BUTTON: "CONTACT_LISTS_CREATE_BUTTON",
    DEPOSIT_DATE_INPUT: "DEPOSIT_DATE_INPUT",
    TOGGLE_SWITCH_YES: "TOGGLE_SWITCH_YES",
    DEPOSIT_AMOUNT_INPUT: "DEPOSIT_AMOUNT_INPUT",
    BOOKING_DEPOSIT_TOGGLE: "BOOKING_DEPOSIT_TOGGLE",
    SPORTSMAN_NOTIFICATION_TOGGLE: "SPORTSMAN_NOTIFICATION_TOGGLE",
    COLLECT_PAYMENT_TOGGLE: "COLLECT_PAYMENT_TOGGLE",
    EMAIL_PAYMENT_LINK_TOGGLE: "EMAIL_PAYMENT_LINK_TOGGLE",
    CREATE_BOOKING_BUTTON: "CREATE_BOOKING_BUTTON",
    CANCEL_PAYMENT_DUE_DATE_BUTTON: "CANCEL_PAYMENT_DUE_DATE_BUTTON",
    CONFIRM_PAYMENT_DUE_DATE_BUTTON: "CONFIRM_PAYMENT_DUE_DATE_BUTTON",
    EDIT_PAYMENT_BUTTON: "EDIT_PAYMENT_BUTTON",
    CUSTOM_PROPERTY_LABEL_INPUT: "CUSTOM_PROPERTY_LABEL_INPUT",
    CUSTOM_PROPERTY_TYPE_SELECT: "CUSTOM_PROPERTY_TYPE_SELECT",
    CUSTOM_PROPERTY_DESCRIPTION_INPUT: "CUSTOM_PROPERTY_DESCRIPTION_INPUT",
    ARCHIVE_BUTTON: "ARCHIVE_BUTTON",
    SAVE_BUTTON: "SAVE_BUTTON",
    AD_ACCOUNT_SELECT: "AD_ACCOUNT_SELECT",
    FACEBOOK_PAGE_SELECT: "FACEBOOK_PAGE_SELECT",
    FORM_EXPAND_BUTTON: "FORM_EXPAND_BUTTON",
    SIDEBAR_EMBEDDED: "SIDEBAR_EMBEDDED",
    SIDEBAR_DRAWER: "SIDEBAR_DRAWER",
    PAGE_HEADER: "PAGE_HEADER",
    HUBSPOT_MENU_ITEM: "HUBSPOT_MENU_ITEM",
    GROUP_MEMBER_TAG: "GROUP_MEMBER_TAG",
    COLLAPSED_SECTION_BUTTON: "COLLAPSED_SECTION_BUTTON",
    ADD_ON_ITEM: "ADD_ON_ITEM",
    GROSS_BOOKINGS: "GROSS_BOOKINGS",
    OUTFITTER_STATS: "OUTFITTER_STATS",
    BOOKING_ACTIONS: "BOOKING_ACTIONS",
    EDITABLE_FIELDS_ICONS: "EDITABLE_FIELDS_ICONS",
    ADD_ONS_ICONS: "ADD_ONS_ICONS",
    BOOKING_INVITE_MODAL: "BOOKING_INVITE_MODAL",
    GENERIC_SELECT: "GENERIC_SELECT",
    NUMBER_OF_GUESTS_INPUT: "NUMBER_OF_GUESTS_INPUT",
    BOOKING_INVITE_EDITABLE_BUTTON: "BOOKING_INVITE_EDITABLE_BUTTON",
    MOBILE_DROPDOWN: "MOBILE_DROPDOWN",
    DESKTOP_DROPDOWN: "DESKTOP_DROPDOWN",
    EDIT_BOOKING_TIME_WINDOWS: "EDIT_BOOKING_TIME_WINDOWS",
    EDIT_RATES_FORM: "EDIT_RATES_FORM",
    CANCEL_BUTTON: "CANCEL_BUTTON",
    IMPORT_BUTTON: "IMPORT_BUTTON",
    BOOKING_IMPORT_BUTTON: "BOOKING_IMPORT_BUTTON",
    BOOKING_IMPORT_LISTING_SELECT: "BOOKING_IMPORT_LISTING_SELECT",
    BOOKING_IMPORT_PACKAGE_SELECT: "BOOKING_IMPORT_PACKAGE_SELECT",
    BOOKING_IMPORT_REUPLOAD_BUTTON: "BOOKING_IMPORT_REUPLOAD_BUTTON",
    BOOKING_IMPORT_ROW_ERRORS: "BOOKING_IMPORT_ROW_ERRORS",
    SEARCH_INPUT: "SEARCH_INPUT",
    SEARCH_CONTAINER: "SEARCH_CONTAINER",
    SEARCH_RESULT_AVATAR: "SEARCH_RESULT_AVATAR",
    SEARCH_RESULT_ICON: "SEARCH_RESULT_ICON",
    RADIO_OPTION: "RADIO_OPTION_",
    LOADING_DOTS: "LOADING_DOTS",
    OUTFITTER_ACTIONS: "OUTFITTER_ACTIONS",
    OUTFITTER_OWNER_WARNING: "outfitter-owner-warning",
    SPINNER: "SPINNER",
    PREVIOUS_MONTH: "PREVIOUS_MONTH",
    NEXT_MONTH: "NEXT_MONTH",
    IMAGE_SKELETON: "IMAGE_SKELETON",
    IMAGE: "IMAGE",
    QR_CODE: "QR_CODE",
    PHONE_COUNTRY_SELECT: "phone-country-select",
    PHONE_NUMBER_INPUT: "phone-number-input",
    IS_HIDDEN_FROM_SPORTMEN_HELP_ICON: "IS_HIDDEN_FROM_SPORTMEN_HELP_ICON",
    ADD_QUANTITY_BUTTON: "ADD_QUANTITY_BUTTON",
    ADD_BUTTON: "ADD_BUTTON",
    REMOVE_BUTTON: "REMOVE_BUTTON",
    PREVIEW_BOX: "PREVIEW_BOX",
    ELLIPSIS_MENU: "ELLIPSIS_MENU",
    AMOUNT_INPUT: "AMOUNT_INPUT",
    RESPONSIBLE_PARTY_INPUT: "RESPONSIBLE_PARTY_INPUT",
    APPROVED_BY_INPUT: "APPROVED_BY_INPUT",
    STRIPE_REASON_INPUT: "STRIPE_REASON_INPUT",
    USER_REASON_INPUT: "USER_REASON_INPUT",
    STRIPE_PAYMENT_LINK_BUTTON: "STRIPE_PAYMENT_LINK_BUTTON",
    SUBSCRIPTION_PILL: "SUBSCRIPTION_PILL",
    COPY_INPUT: "COPY_INPUT",
    DROPZONE: "DROPZONE",
    SPECIES_SELECT: "SPECIES_SELECT",
    BOOKING_DATES_TRIGGER: "BOOKING_DATES_TRIGGER",
    PAGE_SIZE_SELECT: "PAGE_SIZE_SELECT",
    SORT_SELECT: "SORT_SELECT",
    PREV_PAGE_BUTTON: "PREV_PAGE_BUTTON",
    NEXT_PAGE_BUTTON: "NEXT_PAGE_BUTTON",
    MENU_SELECT_CONTROL_BUTTON: "MENU_SELECT_CONTROL_BUTTON",
    PORTAL_ENTITY_SELECTOR: "PORTAL_ENTITY_SELECTOR",
    LISTING_SELECT: "LISTING_SELECT",
    TABLE_PAGINATION: "TABLE_PAGINATION",
    REFERRAL_STATUS_SELECT: "REFERRAL_STATUS_SELECT",
    GUIDE_SELECT: "GUIDE_SELECT",
    GEAR_MENU_BUTTON: "GEAR_MENU_BUTTON",
    AVAILABILITY_BANNER: "AVAILABILITY_BANNER",
    SELECT_INPUT: "SELECT_INPUT",
    DELETE_HOSTED_VIDEO: "DELETE_HOSTED_VIDEO",
    HOSTED_VIDEO_URL: "HOSTED_VIDEO_URL",
    CLOSE_SIDE_DRAWER_BUTTON: "CLOSE_SIDE_DRAWER_BUTTON",
    TIME_BUTTON: "TIME_BUTTON",
    TIME_DISPLAY: "TIME_DISPLAY",
    ARCHIVED_FILTER_SELECT: "ARCHIVED_FILTER_SELECT",
    SELECT_GUIDE_BUTTON: "SELECT_GUIDE_BUTTON",
    DELETE_BUTTON: "DELETE_BUTTON",
    VERIFY_BUTTON: "VERIFY_BUTTON",
    EDIT_BUTTON: "EDIT_BUTTON",
    CONFIRMATION_ALERT_CONFIRM: "CONFIRMATION_ALERT_CONFIRM",
    LOCK_ICON: "LOCK_ICON",
    MENU_ITEM: "MENU_ITEM",
    BOOKING_INVITE_SPORTSMAN_COLUMN: "BOOKING_INVITE_SPORTSMAN_COLUMN",
    BOOKING_INVITE_LISTING_PACKAGES_COLUMN:
        "BOOKING_INVITE_LISTING_OUTFITTER_COLUMN",
    BOOKING_INVITE_COUPON_COLUMN: "BOOKING_INVITE_COUPON_COLUMN",
    BOOKING_INVITE_NOTE_COLUMN: "BOOKING_INVITE_NOTE_COLUMN",
    BOOKING_INVITE_DATES_AND_GUESTS_COLUMN:
        "BOOKING_INVITE_DATES_AND_GUESTS_COLUMN",
    POPOVER_TRIGGER: "POPOVER_TRIGGER",
    ADD_ON_HOVER_ICON: "ADD_ON_HOVER_ICON",
    EDITABLE_FIELD_ICON: "EDITABLE_FIELD_ICON",
    BOOKING_INVITE_ADD_ONS_COLUMN: "BOOKING_INVITE_ADD_ONS_COLUMN",
    AUTHENTICATING_LOADER: "AUTHENTICATING_LOADER",
    OFFSITE_BOOKING_NOTES_INPUT: "OFFSITE_BOOKING_NOTES_INPUT",
    BANNER_CTA_LINK: "BANNER_CTA_LINK",
    BANNER_CLOSE_BUTTON: "BANNER_CLOSE_BUTTON",
    RATES_MANAGE_SUBTEXT: "RATES_MANAGE_SUBTEXT",
    EDIT_PAYMENT_FEE_SETTINGS_FORM: "EDIT_PAYMENT_FEE_SETTINGS_FORM",
    PROFILE_BUTTON: "PROFILE_BUTTON",
    PROFILE_BUTTON_IMPERSONATING_AVATAR_INDICATOR:
        "PROFILE_BUTTON_IMPERSONATING_AVATAR_INDICATOR",
    HELP_MENU_BUTTON: "HELP_MENU_BUTTON",
    WEBSITE_RATE_INPUT: "WEBSITE_RATE_INPUT",
    MARKETPLACE_QUOTE_RATE_INPUT: "MARKETPLACE_QUOTE_RATE_INPUT",
    STANDARD_QUOTE_RATE_INPUT: "STANDARD_QUOTE_RATE_INPUT",
    WIDGET_RATE_INPUT: "WIDGET_RATE_INPUT",
    DASHBOARD_RATE_INPUT: "DASHBOARD_RATE_INPUT",
    LEFT_ICON: "LEFT_ICON",
    RIGHT_ICON: "RIGHT_ICON",
    IFRAME: "IFRAME",
    REPORTING_SECTION_TITLE: "reporting-section-title",
    VIEW_MORE_LINK: "view-more-link",
    PROGRESS_COMPLETE: "PROGRESS_COMPLETE",
    PROGRESS_INCOMPLETE: "PROGRESS_INCOMPLETE",
    REVIEW_CARD: "REVIEW_CARD",
    EVENT_CARD: "EVENT_CARD",
    BOOKING_DETAILS: "BOOKING_DETAILS",
    BOOKING_INVITE_DETAILS: "BOOKING_INVITE_DETAILS",
    LOCATION_PREVIEW_MAP: "LOCATION_PREVIEW_MAP",
    VIEW_CHECK_IN_SETTINGS: "VIEW_CHECK_IN_SETTINGS",
    PAYMENT_SETTINGS_VIEW: "PAYMENT_SETTINGS_VIEW",
    ADD_ONS_VIEW: "ADD_ONS_VIEW",
    LODGING_MODAL: "LODGING_MODAL",
    PRICING_PACKAGE_ITEM: "PRICING_PACKAGE_ITEM",
    ADD_ONS_PREVIEW: "ADD_ONS_PREVIEW",
    AVAILABILITY_MODAL: "AVAILABILITY_MODAL",
    AVAILABILITY_FORM: "AVAILABILITY_FORM",
    AVAILABILITY_REVIEW_CALENDAR: "AVAILABILITY_REVIEW_CALENDAR",
    DEFAULT_AVAILABILITY_RULE_CALENDAR: "DEFAULT_AVAILABILITY_RULE_CALENDAR",
    DEFAULT_AVAILABILITY_RULE_NAME_INPUT:
        "DEFAULT_AVAILABILITY_RULE_NAME_INPUT",
    DONE_DEFAULT_AVAILABILITY_RULE_BUTTON:
        "DONE_DEFAULT_AVAILABILITY_RULE_BUTTON",
    SELF_ONBOARD_NAVIGATION: "SELF_ONBOARD_NAVIGATION",
    HUBSPOT_CHAT_CLOSE_BUTTON: "HUBSPOT_CHAT_CLOSE_BUTTON",
    OUTFITTER_DOCUMENTS_PREVIEW: "OUTFITTER_DOCUMENTS_PREVIEW_",
    RESOURCE_TYPE_SELECT: "RESOURCE_TYPE_SELECT",
    RESOURCE_SELECT: "RESOURCE_SELECT",
    CREATE_OUTFITTER_DOCUMENT_MENU: "CREATE_OUTFITTER_DOCUMENT_MENU",
    EDIT_OUTFITTER_DOCUMENT_MENU_BUTTON: "EDIT_OUTFITTER_DOCUMENT_MENU_BUTTON_",
    EDIT_OUTFITTER_DOCUMENT_MENU: "EDIT_OUTFITTER_DOCUMENT_MENU_",
    ASSIGN_ENTITIES_ELLIPSIS_MENU_BUTTON:
        "ASSIGN_ENTITIES_ELLIPSIS_MENU_BUTTON",
    ASSIGN_ENTITIES_ELLIPSIS_MENU: "ASSIGN_ENTITIES_ELLIPSIS_MENU",
    ADD_AMENITY_BUTTON: "ADD_AMENITY_BUTTON",
    EDIT_AMENITY_BUTTON: "EDIT_AMENITY_BUTTON",
    EDIT_LICENSE_BUTTON: "EDIT_LICENSE_BUTTON",
    LICENSE_GENERAL_INFO_INPUT_URL_INPUT:
        "LICENSE_GENERAL_INFO_INPUT_URL_INPUT",
    HUNTING_INFORMATION_URL_INPUT: "HUNTING_INFORMATION_URL_INPUT",
    FISHING_INFORMATION_URL_INPUT: "FISHING_INFORMATION_URL_INPUT",
    ONLINE_PORTAL_URL_INPUT: "ONLINE_PORTAL_URL_INPUT",
    SEARCHABLE_KEYWORD_INPUT: "SEARCHABLE_KEYWORD_INPUT",
    ADD_SEARCHABLE_KEYWORD_BUTTON: "ADD_SEARCHABLE_KEYWORD_BUTTON",
    IMAGE_URL_INPUT: "IMAGE_URL_INPUT",
    NAME_INPUT: "NAME_INPUT",
    EDIT_SPECIES_BUTTON: "EDIT_SPECIES_BUTTON",
    DELETE_SPECIES_BUTTON: "DELETE_SPECIES_BUTTON",
    BOOKING_INVITES_FILTERS: "BOOKING_INVITES_FILTERS",
    SEND_QUOTE_TABS: "SEND_QUOTE_TABS",
    BOOKING_INVITE_REQUESTS_CONTACT_CELL:
        "BOOKING_INVITE_REQUESTS_CONTACT_CELL",
    BOOKING_INVITE_REQUEST_DETAILS: "BOOKING_INVITE_REQUEST_DETAILS",
    CONTACT_NOTES_INPUT: "CONTACT_NOTES_INPUT",
    CONTACT_HEADER_ELLIPSIS_MENU: "CONTACT_HEADER_ELLIPSIS_MENU",
    OPT_OUT_OF_MARKETING_CONFIRMATION: "OPT_OUT_OF_MARKETING_CONFIRMATION",
    CONTACT_MARKETING_OPT_OUT_STATUS: "CONTACT_MARKETING_OPT_OUT_STATUS",
    SUBMENU_ICON: "SUBMENU_ICON",
    LEADS_BOARD_COLUMNS: "LEADS_BOARD_COLUMNS",
    LEADS_BOARD_DROP_PLACEHOLDER: "LEADS_BOARD_DROP_PLACEHOLDER",
    LEADS_CREATE_BUTTON: "LEADS_CREATE_BUTTON",
    LEADS_IMPORT_CSV_BUTTON: "leads-import-csv-button",
    CUSTOM_PROPERTIES_CREATE_BUTTON: "CUSTOM_PROPERTIES_CREATE_BUTTON",
    LEADS_CREATE_BRIEF_DESCRIPTION_INPUT:
        "LEADS_CREATE_BRIEF_DESCRIPTION_INPUT",
    LEADS_CREATE_FIRST_NAME_INPUT: "LEADS_CREATE_FIRST_NAME_INPUT",
    LEADS_CREATE_LAST_NAME_INPUT: "LEADS_CREATE_LAST_NAME_INPUT",
    LEADS_CREATE_EMAIL_INPUT: "LEADS_CREATE_EMAIL_INPUT",
    CHAT_INPUT_ATTACH_BUTTON: "CHAT_INPUT_ATTACH_BUTTON",
    CHAT_INPUT_FILE_INPUT: "CHAT_INPUT_FILE_INPUT",
    CHAT_INPUT_ATTACHMENT: "CHAT_INPUT_ATTACHMENT",
    CHAT_INPUT_ATTACHMENT_UPLOADING: "CHAT_INPUT_ATTACHMENT_UPLOADING",
    CHAT_ATTACHMENT_FILE_ICON: "CHAT_ATTACHMENT_FILE_ICON",
    CHAT_INPUT_REMOVE_ATTACHMENT_BUTTON: "CHAT_INPUT_REMOVE_ATTACHMENT_BUTTON",
    CHAT_INPUT_SUBMIT_BUTTON: "CHAT_INPUT_SUBMIT_BUTTON",
    CHAT_TYPING_INDICATOR: "CHAT_TYPING_INDICATOR",
    CHAT_ERROR_BANNER: "CHAT_ERROR_BANNER",
    CHAT_ERROR_RETRY_BUTTON: "CHAT_ERROR_RETRY_BUTTON",
    CHAT_MESSAGE_DEBUG: "CHAT_MESSAGE_DEBUG",
    CHAT_MESSAGE_TOOL_CALL: "CHAT_MESSAGE_TOOL_CALL",
    CHAT_MESSAGE_TOOL_CALL_ERROR: "CHAT_MESSAGE_TOOL_CALL_ERROR",
    CHAT_MESSAGE_SOURCE: "CHAT_MESSAGE_SOURCE",
    CHAT_MESSAGE_FILE: "CHAT_MESSAGE_FILE",
    CHAT_MESSAGE_STEP_SEPARATOR: "CHAT_MESSAGE_STEP_SEPARATOR",
    OUTFITTER_ASSISTANT_BUBBLE: "OUTFITTER_ASSISTANT_BUBBLE",
    OUTFITTER_ASSISTANT_PANEL: "OUTFITTER_ASSISTANT_PANEL",
    OUTFITTER_ASSISTANT_CLOSE: "OUTFITTER_ASSISTANT_CLOSE",
    OUTFITTER_ASSISTANT_HISTORY_BUTTON: "OUTFITTER_ASSISTANT_HISTORY_BUTTON",
    OUTFITTER_ASSISTANT_HISTORY_BACK: "OUTFITTER_ASSISTANT_HISTORY_BACK",
    OUTFITTER_ASSISTANT_HISTORY_LIST: "OUTFITTER_ASSISTANT_HISTORY_LIST",
    OUTFITTER_ASSISTANT_HISTORY_ITEM: "OUTFITTER_ASSISTANT_HISTORY_ITEM",
    ASSISTANT_USER_SELECTION_CARD: "ASSISTANT_USER_SELECTION_CARD",
    ASSISTANT_PLAN_CARD: "ASSISTANT_PLAN_CARD",
    ASSISTANT_PLAN_CONTINUE_BUTTON: "ASSISTANT_PLAN_CONTINUE_BUTTON",
    ASSISTANT_USER_SELECTION_OPTION: "ASSISTANT_USER_SELECTION_OPTION",
    LEAD_NOTE_FORM_SUBMIT_BUTTON: "LEAD_NOTE_FORM_SUBMIT_BUTTON",
    CALENDAR_EVENT_DETAILS: "CALENDAR_EVENT_DETAILS",
    COLOR_PICKER: "COLOR_PICKER",
    NEW_ENTITY_BUTTON: "NEW_ENTITY_BUTTON",
    CONTINUE_BUTTON: "CONTINUE_BUTTON",
    TRAIT_SELECT_INPUT: "TRAIT_SELECT_INPUT",
    SIDEBAR_GROUP_HEADER: "SIDEBAR_GROUP_HEADER",
    UPLOAD_IMAGE_BUTTON: "UPLOAD_IMAGE_BUTTON",
    REORDER_ADD_ON_BUTTON: "REORDER_ADD_ON_BUTTON",
    THEME_SETTINGS_INPUTS: "THEME_SETTINGS_INPUTS",
    PREVIOUS: "PREVIOUS",
    NEXT: "NEXT",
    LOADING_SKELETON: "LOADING_SKELETON",
    HOME_PAGE_LOADING_SKELETON: "HOME_PAGE_LOADING_SKELETON",
    DASHBOARD_SIDEBAR: "DASHBOARD_SIDEBAR",
    DASHBOARD_SECTION: "DASHBOARD_SECTION",
    SIDEBAR_ACTIVE_BAR: "SIDEBAR_ACTIVE_BAR",
    SIDEBAR_ICON: "SIDEBAR_ICON",
    TEMPLATE_SELECT: "TEMPLATE_SELECT",
    TEMPLATE_SEND_TEST_ACTION: "TEMPLATE_SEND_TEST_ACTION",
    DESCRIPTION_INPUT: "DESCRIPTION_INPUT",
    ICON_URL_INPUT: "ICON_URL_INPUT",
    CUSTOM_FIELD_CARD: "CUSTOM_FIELD_CARD",
    DRAG_HANDLE: "DRAG_HANDLE",
    DRAG_AND_DROP_LIST: "DRAG_AND_DROP_LIST",
    DRAG_AND_DROP_LIST_ITEM: "DRAG_AND_DROP_LIST_ITEM",
    EDITOR_TOP_BAR_BUTTONS: "EDITOR_TOP_BAR_BUTTONS",
    FEEDBACK_OVERLAY_ITEM: "FEEDBACK_OVERLAY_ITEM",
    FEEDBACK_OVERLAY_BUBBLE: "FEEDBACK_OVERLAY_BUBBLE",
    FEEDBACK_PAGE_SELECTOR: "FEEDBACK_PAGE_SELECTOR",
    AVAILABILITY_UPDATE_FORM: "AVAILABILITY_UPDATE_FORM",
    LAST_PAYMENT_CONFIG_INPUT: "LAST_PAYMENT_CONFIG_INPUT",
    PORTAL_SELECTED_ENTITY: "PORTAL_SELECTED_ENTITY",
    CENTERED_CARD_LAYOUT: "CENTERED_CARD_LAYOUT",
    CENTERED_CARD_LAYOUT_ACTIONS: "CENTERED_CARD_LAYOUT_ACTIONS",
    APP_PROMPT_GATE: "APP_PROMPT_GATE",
    APP_PROMPT_TITLE: "APP_PROMPT_TITLE",
    APP_PROMPT_MESSAGE: "APP_PROMPT_MESSAGE",
    APP_PROMPT_CTA: "APP_PROMPT_CTA",
    APP_PROMPT_IMAGE: "APP_PROMPT_IMAGE",
    FEATURE_GATE_TITLE: "FEATURE_GATE_TITLE",
    FEATURE_GATE_MESSAGE: "FEATURE_GATE_MESSAGE",
    FEATURE_GATE_CTA: "FEATURE_GATE_CTA",
    FEATURE_GATE_IMAGE: "FEATURE_GATE_IMAGE",
}

export const RESOURCES_URL = "https://resources.mallardbay.com/"
export const CALENDAR_SYNC_HELP_URL =
    "https://resources.mallardbay.com/how-can-i-sync-3rd-party-bookings-to-my-mallard-bay-calendar#:~:text=Common%203rd%20Party%20Integrations"

export const FEATURE_REQUEST_URL = "https://feature-requests.mallardbay.com/"

export const UPLOAD_CARE_BASE_DOMAIN = "ucarecdn.com"

const PAGE_HEADER_HEIGHT_PX = 64
const PAGE_HEADER_DIVIDER_HEIGHT_RATIO = 0.375

export const PAGE_HEADER_HEIGHT = `${PAGE_HEADER_HEIGHT_PX}px`
export const PAGE_HEADER_DIVIDER_HEIGHT = `${
    PAGE_HEADER_HEIGHT_PX * PAGE_HEADER_DIVIDER_HEIGHT_RATIO
}px`

export const APPLE_APP_ID = "1665775548"

export const MOBILE_APP_URL = `https://apps.apple.com/us/app/guidetech-by-mallard-bay/id${APPLE_APP_ID}`

export const PROFILE_MENU_LABELS = {
    VIEW_AS_LABEL: "View as...",
    STOP_VIEWING_AS_LABEL: "Stop viewing as",
    LOG_OUT_LABEL: "Log out",
    ACCOUNT_SETTINGS: "Account settings",
    BILLING: "Billing",
    ASK_A_QUESTION: "Ask a question",
    REQUEST_SUBSCRIPTION_CHANGES: "Request subscription changes",
    REQUEST_FEATURE: "Request a Feature",
    KNOWLEDGE_BASE: COPY.KNOWLEDGE_BASE,
}

export const HUBSPOT_INLINE_EMBED_ELEMENT_ID =
    "hubspot-conversations-inline-embed-selector"

export const TYPE_NAMES = {
    EVENT_GROUP: "EventGroup",
    CUSTOM_EMAIL_DOMAIN_DNS_RECORD: "CustomEmailDomainDnsRecord",
    CUSTOM_EMAIL_DOMAIN_CONFIG: "CustomEmailDomainConfig",
    RESOURCE_WITH_AVAILABILITY_SUPPORT: "ResourceWithAvailabilitySupport",
    OUTFITTER_BOOKING_CLIENT: "OutfitterBookingClient",
    CONTACT_LISTS_RESULTS: "ContactListsResults",
    CONTACT_LIST: "ContactList",
    GET_ENTITY_CUSTOM_PROPERTIES_RESULT: "GetEntityCustomPropertiesResult",
    ENTITY_CUSTOM_PROPERTY: "EntityCustomProperty",
    ENTITY_PROPERTY_VALUE: "EntityPropertyValue",
    ADDRESS: "Address",
    REMAINING_PAYMENT: "RemainingPayment",
    PAYMENT_BLOCK: "PaymentBlock",
    BANNER: "Banner",
    BANNER_CONTENT: "BannerContent",
    CALL_TO_ACTION: "CallToAction",
    BOOKING: "Booking",
    QUOTE_PACKAGE: "QuotePackage",
    QUOTE_ADD_ON: "QuoteAddOn",
    OUTFITTER: "Outfitter",
    QUOTE_ITEM: "QuoteItem",
    DENIAL_REASON: "DenialReason",
    AVAILABILITY: "Availability",
    GENERIC_AVAILABILITY_ENTRY: "GenericAvailabilityEntry",
    GROUP_PAY_SHARE: "GroupPayShare",
    SLOT_SHARE: "SlotShare",
    GROUP_PAY_MEMBER: "GroupPayMember",
    PAYMENT: "Payment",
    PAYMENT_REQUEST: "PaymentRequest",
    PAYMENT_ITEM_REQUEST: "PaymentItemRequest",
    TEAM_MEMBER: "TeamMember",
    USER: "User",
    BOOKING_INVITE_USER: "BookingInviteUser",
    VALUE_CHANGE: "ValueChange",
    LISTING: "Listing",
    PRICING_PACKAGE: "PricingPackage",
    BOOKING_INVITE: "BookingInvite",
    BOOKING_INVITE_EDITABLE_FIELDS: "BookingInviteEditableFields",
    ADD_ON: "AddOn",
    COUPON: "Coupon",
    DEAL_ATTRIBUTION_OPTION: "DealAttributionOption",
    ADDITIONAL_PAYMENT_SUMMARY: "AdditionalPaymentSummary",
    PAYOUT: "Payout",
    PAYOUT_TRANSACTION: "PayoutTransaction",
    PAYOUT_TIMELINE: "PayoutTimeline",
    OUTFITTER_SLUG: "OutfitterSlugResult",
    SPECIES: "Species",
    CALENDAR_SUBSCRIPTION: "CalendarSubscription",
    LICENSE_INFO: "LicenseInfo",
    LINE_ITEM: "LineItem",
    CANCELLATION_POLICY: "CancellationPolicy",
    OUTFITTER_CANCELLATION_POLICY: "OutfitterCancellationPolicy",
    BOOKING_CANCELLATION_MEMBER_INFO: "BookingCancellationMemberInfo",
    BOOKING_CANCELLATION_INFO: "BookingCancellationInfo",
    BOOKING_PAYMENT_SUMMARY: "BookingPaymentSummary",
    MEMBER_PAYMENT_SUMMARY: "MemberPaymentSummary",
    PAYMENT_SETTINGS: "PaymentSettings",
    PAYMENT_RETRY: "PaymentRetry",
    STRIPE_SETUP_INTENT: "StripeSetupIntent",
    STRIPE_PAYMENT_INTENT: "StripePaymentIntent",
    PAYMENT_SUMMARY: "PaymentSummary",
    QUOTE_PRICE: "QuotePrice",
    CHECK_IN_CONFIG: "CheckInConfig",
    ADDITIONAL_BOOKING_PAYMENT_SUMMARY: "AdditionalBookingPaymentSummary",
    FEATURE_ACCESS: "FeatureAccess",
    FEATURE_ACCESS_SETTING: "FeatureAccessSetting",
    ONBOARDING: "Onboarding",
    ONBOARDING_RESULTS: "OnboardingQueryResults",
    ONBOARDING_SUBSCRIPTION_OPTIONS: "OnboardingSubscriptionOptions",
    ONBOARDING_TASK: "OnboardingTask",
    ONBOARDING_TASK_ACTION: "OnboardingTaskAction",
    ONBOARDING_TASK_SECTION: "OnboardingTaskSection",
    ID_AND_NAME: "IdAndName",
    OUTFITTER_SUBSCRIPTION_INFO: "OutfitterSubscriptionInfo",
    OUTFITTER_FEATURE_ACCESS_INFO: "OutfitterFeatureAccessInfo",
    LISTING_PROGRESS: "ListingProgress",
    LODGING: "Lodging",
    TRIP_ITINERARY: "TripItinerary",
    TRIP_ITINERARY_ITEM: "TripItineraryItem",
    RESOURCE: "Resource",
    OUTFITTER_DOCUMENT: "OutfitterDocument",
    WIDGET: "Widget",
    AMENITY: "Amenity",
    CONTACT: "Contact",
    CONTACT_MARKETING_OPT_OUT_STATUS: "ContactMarketingOptOutStatus",
    LEAD: "Lead",
    NOTE: "Note",
    QUOTE_REQUEST: "QuoteRequest",
    OUTFITTER_INTEGRATION_SETTINGS: "OutfitterIntegrationSettings",
    QUICK_BOOKS_COMPANY_INFO: "QuickBooksCompanyInfo",
    QUICK_BOOKS_DEPOSIT_ACCOUNTS_RESULT: "QuickBooksDepositAccountsResult",
    QUICK_BOOKS_DEPOSIT_ACCOUNT: "QuickBooksDepositAccount",
    QUICK_BOOKS_INTEGRATION_SETTINGS: "QuickBooksIntegrationSettings",
    QUICK_BOOKS_CLASSES_RESULT: "QuickBooksClassesResult",
    QUICK_BOOKS_ITEMS_RESULT: "QuickBooksItemsResult",
    QUICK_BOOKS_CLASS: "QuickBooksClass",
    QUICK_BOOKS_ITEM: "QuickBooksItem",
    QUICK_BOOKS_LISTING_CLASS_MAPPING: "QuickBooksListingClassMapping",
    QUICK_BOOKS_ITEM_MAPPING: "QuickBooksItemMapping",
    QUICK_BOOKS_CLASS_MAPPING_RESULT: "QuickBooksClassMappingsResult",
    QUICK_BOOKS_ITEM_LISTING_MAPPING_RESULT:
        "QuickBooksItemListingMappingsResult",
    QUICK_BOOKS_ITEM_OUTFITTER_MAPPING_RESULT:
        "QuickBooksItemOutfitterMappingsResult",
    PUBLIC_USER: "PublicUser",
    RICH_TEXT_AI_SUGGESTION: "RichTextAiSuggestion",
    MINIMAL_RESOURCE: "MinimalResource",
    SYNCED_CALENDAR: "SyncedCalendar",
    CALENDAR_EVENT: "CalendarEvent",
    CALENDAR_EVENT_DETAILS_ITEM: "CalendarEventDetailsItem",
    CALENDAR_EVENT_COLORS: "CalendarEventColors",
    CALENDAR_EVENT_CALCULATED_COLORS: "CalendarEventCalculatedColors",
    EVENT_DATE: "CalendarEventDate",
    FORM: "Form",
    WEBSITE: "Website",
    META_CONNECTIONS_RESULT: "MetaConnectionsResult",
    META_CONNECTION: "MetaConnection",
    REVIEW_AGGREGATION: "ReviewAggregation",
    REVIEW: "Review",
    FORM_SUBMISSION: "FormSubmission",
    FORM_SUBMISSION_ANSWER_VALUE: "FormSubmissionAnswerValue",
    FORM_INPUT: "FormInput",
    SOURCE_FORM_DATA_FIELD: "SourceFormDataField",
    MEDIA: "Media",
    PHOTO_GROUP: "PhotoGroup",
    BADGE: "Badge",
    OUTFITTER_IMAGE: "OutfitterImage",
    OUTFITTER_IMAGE_GROUP: "OutfitterImageGroup",
    META_AD_ACCOUNT: "MetaAdAccount",
    META_AD_CAMPAIGN: "MetaAdCampaign",
    META_AD_SET: "MetaAdSet",
    META_AD: "MetaAd",
    META_AD_ACCOUNTS_RESULTS: "MetaAdAccountsResults",
    META_AD_CAMPAIGNS_RESULTS: "MetaAdCampaignsResults",
    META_AD_SETS_RESULTS: "MetaAdSetsResults",
    META_ADS_RESULTS: "MetaAdsResults",
    META_AGGREGATED_AD_METRICS_RESULT: "MetaAggregatedAdMetricsResult",
    MESSAGE_TEMPLATE: "MessageTemplate",
    SEND_LOG_MESSAGE: "SendLogMessage",
    MESSAGE_TEMPLATE_EMAIL_CONTENT: "MessageTemplateEmailContent",
    MESSAGE_TEMPLATE_SMS_CONTENT: "MessageTemplateSmsContent",
    MESSAGE_TEMPLATES_RESULTS: "MessageTemplatesResults",
    MESSAGE_TEMPLATE_SEARCH_RESULTS: "MessageTemplateSearchResults",
    META_AD_METRICS_RESULT: "MetaAdMetricsResult",
    META_AD_METRICS: "MetaAdMetrics",
    TEMPLATE_VARIABLE: "TemplateVariable",
    COUNTS_RESPONSE: "CountsResponse",
    COUNTS: "Counts",
    NOTIFICATION_SEND_LOG: "NotificationSendLog",
    NOTIFICATION_SEND_LOGS_RESULTS: "NotificationSendLogsResults",
    SCHEDULED_CONTACT_NOTIFICATION: "ScheduledContactNotification",
    SCHEDULED_CONTACT_NOTIFICATIONS_RESULTS:
        "ScheduledContactNotificationsResults",
    OUTFITTER_CUSTOM_PROPERTY: "OutfitterCustomProperty",
    FAQ_ITEM: "FaqItem",
    OUTFITTER_TAX_DEFINITION: "OutfitterTaxDefinition",
    OUTFITTER_TWILIO_CONFIGURATION: "OutfitterTwilioConfiguration",
    NAVIGATION_MENU_GROUP: "NavigationMenuGroup",
    NAVIGATION_MENU_ITEM: "NavigationMenuItem",
    CTA: "Cta",
    COLOR_MODE_IMAGE: "ColorModeImage",
    FEATURE_GATE: "FeatureGate",
    PORTAL_ENTITIES_RESPONSE: "PortalEntitiesResponse",
    EVENT_ORGANIZER: "EventOrganizer",
    AUCTION_COUNTS: "AuctionCounts",
    AUCTION: "Auction",
    AUCTIONS_RESULTS: "AuctionsResults",
    AUCTION_REQUEST: "AuctionRequest",
    AUCTION_REQUEST_RECIPIENT: "AuctionRequestRecipient",
    AUCTION_REQUEST_BID: "AuctionRequestBid",
    AUCTION_REQUESTS_RESULTS: "AuctionRequestsResults",
    AWARDED_ITEMS_RESULTS: "AwardedItemsResults",
    AWARDED_ITEM: "AwardedItem",
    AWARDED_ITEM_WINNER: "AwardedItemWinner",
} as const

// TODO: make generic
export const ADD_ON_ICON_MAP = {
    [AddOnCategory.Trophy]: faTrophy,
    [AddOnCategory.GunRental]: faPersonRifle,
    [AddOnCategory.MealUpgrade]: faUtensils,
    [AddOnCategory.Other]: faCirclePlus,
} as const

export const BOOKING_INVITE_STEPS = {
    LISTING: "LISTING",
    DATES: "DATES",
    PACKAGE: "PACKAGE",
    GUESTS_AND_ADD_ONS: "GUESTS_AND_ADD_ONS",
    SUMMARY: "SUMMARY",
    PAYMENTS: "PAYMENTS",
    ATTRIBUTION: "ATTRIBUTION",
}

export const CREATE_BOOKING_STEPS = {
    CONFIGURE: "CONFIGURE",
    PAYMENT: "PAYMENT",
}

export const CREATE_PAID_FACEBOOK_AD_STEPS = {
    LISTING: "LISTING",
    AD_DETAILS: "AD_DETAILS",
    AD_CONTENT: "AD_CONTENT",
    REVIEW_AND_APPROVE: "REVIEW_AND_APPROVE",
}

export const RESOURCE_TYPE = {
    LISTING: "LISTING",
    LODGING: "LODGING",
    TEAM_MEMBER: "TEAM_MEMBER",
    VEHICLE: "VEHICLE",
    BOAT: "BOAT",
    ATV: "ATV",
    GEAR: "GEAR",
    BLIND: "BLIND",
}

export const HEIGHT_LESS_HEADER = "calc(100vh - 72px)"

export const BUTTON_TYPES = {
    BUTTON: "button",
    SUBMIT: "submit",
} as const

export const VALIDATION_MESSAGES = {
    OPTION_REQUIRED: "Please select an option",
    PACKAGE_NAME_REQUIRED: "Please provide a package name",
    PACKAGE_PRICE_REQUIRED: "Please provide a price",
    VALID_PRICE: "Please enter a valid price",
    GUESTS_MINIMUM: "Please include at least 1 guest",
    MIN_GUESTS_LESS_THAN_MAX_GUESTS: "Min guests must be less than max guests",
    MIN_GUESTS_EXCEEDS_MAX_GUESTS: "Min guests can not exceed max guests",
    PACKAGE_GUESTS_ARE_THE_SAME:
        "Select group package type if minimum and maximum guests are the same",
    DEPOSIT_AMOUNT: "Please enter an amount",
    DEPOSIT_PERCENTAGE: "Please enter a percentage",
    DEPOSIT_TYPE: "Please select a deposit type",
    DAYS_BEFORE_TRIP_BALANCE_DUE: "Please enter a number of days",
    ALLOW_DEPOSIT: "Please select an option",
    STATEMENT_DESCRIPTOR_REQUIRED: "Please enter a statement descriptor",
    STATEMENT_DESCRIPTOR_TOO_SHORT:
        "Statement descriptor must be at least 5 characters",
    STATEMENT_DESCRIPTOR_TOO_LONG:
        "Statement descriptor must be at most 22 characters",
    DAYS_BEFORE_TRIP_DISABLE_PAYMENT_PLAN:
        "Please enter a number of days before payment plan is disabled",
} as const

export const FORM_MODES = {
    ALL: "all",
} as const

export enum CustomHeaders {
    CLIENT_NAME = "x-client-name",
    CLIENT_VERSION = "x-client-version",
}

export enum Meridiem {
    AM = "AM",
    PM = "PM",
}

export const CLIENT_TYPE = "dashboard"

export const NO_SELECTION_VALUE_FOR_SELECT = ""

export enum ListingStatus {
    IN_PROGRESS = "In progress",
    UNLISTED = "Unlisted",
    LISTED = "Listed",
}

export enum BookingInviteQuoteRates {
    Standard = "STANDARD",
    Marketplace = "MARKETPLACE",
}

export enum CardTagStatus {
    Pending = "PENDING",
    Accepted = "ACCEPTED",
}

export const BookingInviteQuoteRatesToInternalSource = {
    [BookingInviteQuoteRates.Standard]: BookingInternalSource.SendQuote,
    [BookingInviteQuoteRates.Marketplace]:
        BookingInternalSource.SendQuoteMarketplace,
}

export const INTERNAL_SOURCE = "SendQuote"

export const QUERY_STRING_PROPS = {
    BOOKING_INVITE_ID: "booking_invite_id",
    INTERNAL_SOURCE: "is",
    INTERNAL_SOURCE_ENTITY_ID: "isei",
    INTERNAL_SOURCE_ENTITY_TYPE: "iset",
    SOURCE: "source",
    PAYMENT_TYPE: "payment_type",
    RESOURCE_ID: "resource_id",
    RESOURCE_TYPE: "resource_type",
    AMOUNT: "amount",
    QUOTE_REQUEST_ID: "quote_request_id",
    USE_SUBTOTAL: "use_subtotal",
    CURRENT_MONTH: "current_month",
    BACK_ROUTE: "back_route",
    DEFAULT_AVAILABILITY_RULE_ID: "default_availability_rule_id",
    LEAD_ID: "lead_id",
    CONTACT_ID: "contact_id",
    CONTACT_STAGE: "stage",
    /** Legacy inbound links can still pass contact ids under the old client name. */
    LEGACY_CLIENT_ID: "client_id",
    FORM_SUBMISSION_ID: "form_submission_id",
    /** When creating a contact list: `selection` opens manual contact picker; omit for filter-based flow */
    CONTACT_LIST_CREATE: "contact_list_create",
    FORM_ID: "form_id",
    IFRAME_ID: "iframe_id",
    LISTING_ID: "listing_id",
    OUTFITTER_ID: "outfitter_id",
    QUOTE_REQUEST_FILTERS: {
        LISTING_ID: "listing_id",
        IS_ARCHIVED: "is_archived",
    },
    LEAD_FILTERS: {
        QUALITY: "quality",
        REFERRAL_SOURCE: "referral_source",
        HOW_SOON_ARE_YOU_LOOKING_TO_BOOK: "how_soon_are_you_looking_to_book",
        INTEGRATION_SOURCE: "integration_source",
        DATE_ADDED_FROM: "date_added_from",
        DATE_ADDED_TO: "date_added_to",
        AD_NAME: "ad_name",
        GROUP_SIZE_FROM: "group_size_from",
        GROUP_SIZE_TO: "group_size_to",
        TRIP_AMOUNT_FROM: "trip_amount_from",
        TRIP_AMOUNT_TO: "trip_amount_to",
    },
    OUTFITTER_CUSTOM_PROPERTY_FILTERS: {
        ENTITY_TYPE: "entity_type",
        PROPERTY_TYPE: "property_type",
    },
    THREAD_ID: "thread_id",
    IS_FEEDBACK_MODE: "is_feedback_mode",
    IS_REQUESTING_SPORTSMAN_PAYMENT: "is_requesting_sportsman_payment",
    ACTION: "action",
    ACTION_ENTITY_ID: "action_entity_id",
    GLOBAL_OUTFITTER_ID: "global_outfitter_id",
    GLOBAL_EVENT_ORGANIZER_ID: "global_event_organizer_id",
    GLOBAL_PORTAL_TYPE: "global_portal_type",
    PAYMENT_ID: "payment_id",
    EDIT_TEMPLATE_ID: "edit_template_id",
    AUCTION_REQUEST_ID: "auction_request_id",
    AWARDED_ITEM_ID: "awarded_item_id",
}

export enum PaymentType {
    ONLINE = "online",
    CHECK_CASH_OTHER = "check_cash_other",
}

export enum BookingAction {
    SharePayLink = "share_pay_link",
    OpenPaymentDetails = "open_payment_details",
}

export const OUTFITTER_SENT_QUOTE_DEAL_ATTRIBUTION_ID = "outfitter_sent_quote"

export const CARD_BRANDS = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    DISCOVER: "discover",
    AMEX: "amex",
} as const

export const HTTP = "http://"
export const HTTPS = "https://"

export const MAX_STATEMENT_DESCRIPTOR_LENGTH = 22
export const MIN_STATEMENT_DESCRIPTOR_LENGTH = 5

export const TABLE_SEARCH_PARAMS = {
    SORT: "sort",
    PAGE: "page",
    PAGE_SIZE: "pageSize",
    SEARCH: "search",
} as const

export const DEFAULT_PAGE_SIZE = "10"
// table component expects a 1 indexed page
export const DEFAULT_PAGE_NUMBER = "1"
export const DEFAULT_PAGE = parseInt(DEFAULT_PAGE_NUMBER, 10)

export const LISTING_DEFAULTS = {
    type: ListingType.Hunting,
    min_guest: 1,
    max_guest: 6,
    license_required: false,
    meeting_location: null,
    lodgings: [],
    photos: [],
}

export const LISTING_MIN_GUESTS = 1
export const LISTING_MAX_GUESTS = 99
export const LISTING_MAX_TITLE_LENGTH = 250

export const VALIDATION_MODE = {
    ON_BLUR: "onBlur",
    ON_CHANGE: "onChange",
    ON_SUBMIT: "onSubmit",
    ON_TOUCH: "onTouched",
    ALL: "all",
} as const

export enum BookingMetricDateProp {
    CREATED_AT = "created_at",
    START_DATE = "start_date",
}

export enum MetricDateRange {
    THIS_YEAR = "this_year",
    LAST_YEAR = "last_year",
    NEXT_YEAR = "next_year",
}

export const DATE_FORMATS = {
    MONTH_3_LETTER: "MMM",
    MONTH_3_LETTER_YEAR: "MMM, yyyy",
    REDEEM_BY: "LL / dd / yyyy",
    EDIT_TIMESTAMP: "iiii, MMMM d, yyyy 'at' h:mm a",
}

/** Hides the dashboard chrome AND switches auth to the native token bridge (see ~utils/native-auth-bridge). */
export const IS_IN_APP_BROWSER_QUERY_PARAM = "in_app"

/** Persists the in-app browser flag for the session so it survives navigations and reloads inside the webview. */
export const IS_IN_APP_BROWSER_SESSION_STORAGE_KEY = "MB_IS_IN_APP_BROWSER"

export const CURRENCY_LOCALE = {
    US: "en-US",
}

export const ISO_COUNTRY_CODE = {
    US: "US",
}

export const STATE_CODE = {
    GA: "GA",
}
export const HUBSPOT_URL = "https://app.hubspot.com"

export const AUTO_GENERATED_EMAIL_PREFIX = "offsite.booking+"
export const EMAIL_DOMAIN = "@mallardbay.com"

export const ADDITIONAL_PAYMENT_STEPS = {
    USER_AND_ADDONS: "USER_AND_ADDONS",
    PAYMENT_DETAILS: "PAYMENT_DETAILS",
}

// TODO: Move to backend and return in the outfitterFeatureAccessInfo query.
export const PAYWALL_FEATURES_WITH_LIMITS = [
    FeatureKey.TeamMembers,
    FeatureKey.Coupons,
]

export const TABLE_MODAL_SIZE = "5xl"

export const DEFAULT_COLOR: string = "#34ACCB"

export const COLOR_PICKER_PALETTE = [
    DEFAULT_COLOR,
    "#3461CB",
    "#34CB9F",
    "#9F34CB",
    "#5434CB",
    "#CB5334",
    "#CB9F34",
    "#CB3461",
    "#60CB34",
    "#34CB53",
    "#ACCB34",
]

export const FEATURE_KNOWLEDGE_CTA_URL_PATHS = {
    BOOKINGS: "outfitter-success#manage-bookings",
    CALENDAR: "how-do-i-change-my-availability-on-mallard-bay",
    QUOTES: "how-do-i-send-a-quote-to-a-potential-client",
    REPORTING: "how-do-i-use-the-reporting-tool",
    QUICK_PAY: "quick-pay",
    LISTING: "how-do-i-edit-my-outfitter/charter-info",
    OUTFITTER: "how-do-i-edit-my-outfitter/charter-info",
    OUTFITTER_SUCCESS: "outfitter-success",
    QUICK_BOOKS: "how-can-i-setup-an-integration-with-quickbooks",
    META: "how-can-i-import-my-leads",
    SMS: "sms-integration",
    CUSTOM_EMAIL_DOMAIN: "custom-email-domain",
    CONTACTS: "how-do-i-view-my-client-details-in-mallard-bay",
    CUSTOM_PROPERTIES: "how-can-i-set-up-custom-properties",
    LEADS: "how-do-i-manage-my-booking-leads",
    CALENDAR_EXPORTS: "how-do-i-add-my-bookings-to-my-personal-calendar",
    CALENDAR_IMPORTS:
        "how-can-i-sync-3rd-party-bookings-to-my-mallard-bay-calendar",
    WEB_PERFORMANCE: "how-do-i-understand-my-web-performance",
    META_REPORTING: "how-can-i-view-facebook-ad-reporting",
    META_PAID_ADS: "how-can-i-create-a-facebook-ad",
    TEMPLATES: "what-are-templates",
}

export const EDITABLE_LISTING_SECTIONS = {
    BASICS: "basics",
    DESCRIPTION: "description",
    GEAR_LIST: "gear-list",
    PHOTOS: "photos",
    LOCATION: "location",
    SPECIES: "species",
    AMENITIES: "amenities",
    GUIDE: "guide",
    CHECK_IN_SETTINGS: "check-in-settings",
}

export const EDITABLE_OUTFITTER_SECTIONS = {
    PHOTOS: "photos",
    ADMIN_NOTES: "admin_notes",
    VIDEO: "video",
    REVIEW: "review",
    CHECK_IN_SETTINGS: "check_in_settings",
    CANCELLATION_POLICY: "cancellation_policy",
    ADMIN_ACTIONS: "admin_actions",
    ABOUT: "about",
    FAQ: "faq",
    TAX_DEFINITIONS: "tax_definitions",
    FEATURES_AND_NOTES: "features_and_notes",
    ADDRESSES: "addresses",
}

export const MANAGE_OUTFITTER_SUBSECTION_IDS = {
    GENERAL: "general",
    ABOUT: "about",
    ADDRESSES: "addresses",
    TEAM_MEMBERS: "team-members",
    PHOTOS: "photos",
    VIDEO: "video",
    LODGING: "lodging",
    RESOURCES: "resources",
    ADD_ONS: "add-ons",
    CANCELLATION_POLICY: "cancellation-policy",
    CHECK_IN_SETTINGS: "check-in-settings",
    OUTFITTER_DOCUMENTS: "outfitter-documents",
    FAQ: "faq",
    PAYMENT_SETTINGS: "payment-settings",
    RATES: "rates",
    TAX_DEFINITIONS: "tax-definitions",
    POST_BOOKING_PAYMENTS: "post-booking-payments",
    COUPONS: "coupons",
    ADMIN_ACTIONS: "admin-actions",
    FEATURES_AND_NOTES: "features-and-notes",
    BILLING_OWNER: "billing-owner",
    PAYMENT_FEE_SETTINGS: "payment-fee-settings",
} as const

export const DASHBOARD_BOOKING_SOURCES = {
    LEADS_SCREEN: "leads_screen",
    BOOKING_SCREEN: "booking_screen",
    CALENDAR_SCREEN: "calendar_screen",
    CONTACT_SCREEN: "contact_screen",
}

export const OUTFITTER_ONBOARDING_STEPS = {
    NAME: "OUTFITTER_ONBOARDING_NAME_STEP",
    ADDITIONAL_INFO: "OUTFITTER_ONBOARDING_ADDITIONAL_INFO_STEP",
    CHECK_IN: "OUTFITTER_ONBOARDING_CHECK_IN_STEP",
    DESCRIPTION: "OUTFITTER_ONBOARDING_DESCRIPTION_STEP",
    MEDIA: "OUTFITTER_MEDIA_STEP",
    CANCELLATION_POLICY: "OUTFITTER_CANCELLATION_POLICY_STEP",
    EXIT: "OUTFITTER_ONBOARDING_EXIT",
}

export const PAGE_HEADER_MARGIN_TOP = 3

export const DASHBOARD_SIDEBAR_WIDTH = "320px"

export enum CouponType {
    Percent = "percent",
    Value = "value",
}

export const RESOURCE_DEFAULTS = {
    YEAR: 1900,
    CAPACITY: 1,
}

export const HTTP_PREFIX = "http://"
export const HTTPS_PREFIX = "https://"

export const CURRENCY = {
    USD: "USD",
}

// https://design.intuit.com/quickbooks/brand/design-foundations/color/
export const QUICK_BOOKS_BTN_COLOR = "#00892E"
export const QUICK_BOOKS_ICE = "#EAF6F7"

// https://about.meta.com/brand/resources/meta/company-brand/
export const META_BTN_COLOR = "#1877F2"

export const KEYBOARD_KEYS = {
    ENTER: "Enter",
    ESCAPE: "Escape",
}

export const FORM_LEAD_FIELD_TITLE = {
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
    PHONE_NUMBER: "Phone Number",
} as const

export const FORM_LEAD_FIELD_PLACEHOLDER = {
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
    PHONE_NUMBER: "Phone Number",
}

export const STRIPE_PAYMENT_METHOD_TYPES = {
    CARD: "card",
    US_BANK_ACCOUNT: "us_bank_account",
} as const

export const MALLARDBAY_DOMAIN = "@mallardbay.com"

export const UNSELECT_OPTION_ID = "__NONE_SELECTED__"

export const NO_VALUE = "-"

export const RESPONSIVE_BUTTON_SIZE = {
    base: "xs",
    sm: "sm",
    md: "sm",
}

export const PROPERTY_VALUE_FIELDS = {
    STRING_VALUE: "string_value",
    NUMBER_VALUE: "number_value",
    BOOLEAN_VALUE: "boolean_value",
    DATE_VALUE: "date_value",
    IS_NULL: "is_null",
} as const

export const YUP_ERROR_MESSAGE_PROP = "message"

export const TWILIO_LIMITS = {
    MAX_CAMPAIGN_DESCRIPTION_LENGTH: 4096,
    MIN_CAMPAIGN_DESCRIPTION_LENGTH: 40,
    MAX_MESSAGE_SAMPLE_LENGTH: 1024,
    MIN_MESSAGE_SAMPLE_LENGTH: 20,
    MAX_MESSAGE_SAMPLES: 5,
    MIN_MESSAGE_SAMPLES: 2,
}

export const MINUTES_PER_HOUR = 60

/** Midnight (minutes) for availability time window pickers when value is cleared. */
export const AVAILABILITY_TIME_WINDOW_START_OF_DAY_MINUTES = 0

export const MAX_SLOTS = 200
export const MIN_SLOTS = 1

// --- Private file upload (mirrors server src/config/constants.ts) ---------
// Generic backend-owned private file storage. The dashboard uploads raw
// device bytes to the REST endpoint below before referencing the returned
// privateFileId in GraphQL. Keep these values in sync with the server.
// AI-onboarding-specific limits (max source files, allowed extensions/MIME
// types) are added in the chunk that consumes them for form/picker config.

/** Authenticated REST endpoint for private file uploads, relative to the direct REST API base URL. */
export const PRIVATE_FILES_ENDPOINT = "webhooks/private-files"

/** Advisory metadata sent via the X-Private-File-Purpose header. */
export const PRIVATE_FILE_PURPOSE = {
    AI_ONBOARDING_SOURCE: "AI_ONBOARDING_SOURCE",
    GENERAL: "GENERAL",
} as const

export const PRIVATE_FILE_MAX_UPLOAD_BYTES = 20 * 1024 * 1024

// --- AI onboarding document sources (mirrors server src/config/constants.ts) -
// Client-side limits for the document onboarding source picker. They mirror the
// backend so files/URLs are rejected before upload, but the server remains the
// source of truth and re-validates everything.

/** Max combined uploaded files + public URLs per document onboarding. */
export const AI_ONBOARDING_MAX_SOURCE_FILES = 5

const AI_ONBOARDING_SOURCE_ALLOWED_FILE_EXTENSIONS = [
    "doc",
    "docx",
    "htm",
    "html",
    "odt",
    "pdf",
    "rtf",
    "xls",
    "xlsx",
] as const

export const AI_ONBOARDING_SOURCE_ALLOWED_MEDIA_TYPES = [
    "application/pdf",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.oasis.opendocument.text",
    "application/rtf",
    "text/rtf",
    "text/html",
] as const

/** Native file input `accept` attribute, e.g. ".doc,.docx,.pdf". */
export const AI_ONBOARDING_SOURCE_FILE_ACCEPT =
    AI_ONBOARDING_SOURCE_ALLOWED_FILE_EXTENSIONS.map(
        (extension) => `.${extension}`
    ).join(",")
